export default __webpack_public_path__ + "static/media/nt-10.90ec7d3f.png";